import {
    CloudFlareSource,
    Stream,
    QueryStreamStatus,
} from "@/interfaces/plyrSources";
import Axios from "axios";

export class FileService {
    public static async startConvertPptx(
        file: File,
        token: string
    ): Promise<{ data: string; status: number }> {
        const uri = "/api/converter/start_conversion";

        const formdata = new FormData();
        formdata.append("file", file);

        const response = await Axios.put(uri, formdata, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                return {
                    data: response.data.taskId,
                    status: response.status,
                };
            })
            .catch(error => {
                return {
                    data: error.response.data.detail,
                    status: error.response.status,
                };
            });

        return response;
    }

    public static async checkConversion(
        id: string,
        token: string
    ): Promise<
        | { scriptId: string }
        | { done: number; total: number; percentage: string | number }
        | { pending: string }
    > {
        let response;
        const uri = `/api/converter/get_converted_document?task_id=${id}`;
        try {
            response = await Axios.get(uri, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        } catch (error) {
            response = { data: { err: error } };
        }
        return response.data;
    }

    public static async getInvoice(id: string, token: string): Promise<{}> {
        const uri = `/api/file/invoice/${id}`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: "arraybuffer",
        });

        return new Blob([response.data], { type: "application/pdf" });
    }

    public static async getStreams(token: string): Promise<Stream[]> {
        const uri = `/api/file/own_streams/`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }

    public static async getCloudflareStreams(
        token: string
    ): Promise<CloudFlareSource[]> {
        const uri = `/api/file/cloudflare_streams`;
        const response = await Axios.get(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }

    public static async deleteCloudflareStream(
        uid: string,
        token: string
    ): Promise<number> {
        const uri = `/api/file/cloudflare_stream/${uid}`;
        const response = await Axios.delete(uri, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }

    public static async getCloudflareStreamStatus(
        uid: string,
        token: string
    ): Promise<QueryStreamStatus> {
        const uri = `/api/file/cloudflare_stream_status`;
        const response = await Axios.get(uri, {
            params: { uid: uid },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }

    public static async uploadFile(
        widgetId: string,
        file: File
    ): Promise<{
        data: { id: string; filename: string; widgetId: string };
        status: number;
    }> {
        const uri = `/api/file/by_id/${widgetId}`;

        const formdata = new FormData();
        formdata.append("file", file);
        const response = await Axios.post(uri, formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(response => {
                return {
                    data: response.data,
                    status: response.status,
                };
            })
            .catch(error => {
                return {
                    data: error.response.data,
                    status: error.response.status,
                };
            });

        return response;
    }

    public static async requestTusUrl(
        contentSize: string,
        filename: string,
        token: string
    ): Promise<{
        data: { Location: string; "stream-media-id": string };
        status: number;
    }> {
        const uri = `/api/file/requestTusUrl`;

        const response = await Axios.post(
            uri,
            {},
            {
                params: { contentSize: contentSize, filename: filename },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then(response => {
                return {
                    data: response.data,
                    status: response.status,
                };
            })
            .catch(error => {
                return {
                    data: error.response.data,
                    status: error.response.status,
                };
            });

        return response;
    }
    public static async proxyCheck(uri: string): Promise<number> {
        const response = await Axios.get(uri)
            .then(x => {
                return x;
            })
            .catch(error => {
                console.log("errror", error);
                return error.response;
            });
        return response?.status || 500;
    }

    public static async checkIfBrowserIsBlockingVideo(): Promise<boolean> {
        try {
            await Axios.get("/wp-banners.js");
            return false;
        } catch {
            return true;
        }
    }
}
